<template>
  <div
    class="eu-width_100 eu-display_flex emd-progress"
    :style="{ backgroundColor }"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
    <template v-else>
      <emd-progress-bar
        :max="max"
        :value="value"
      />
    </template>
  </div>
</template>

<script>
import EmdProgressBar from '../../atoms/emdProgressBar/EmdProgressBar.vue'

export default {
  name: 'EmdProgress',

  components: {
    EmdProgressBar
  },

  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    max: {
      type: [String, Number],
      default: 100
    },
    backgroundColor: {
      type: String,
      default: '#F2F2F3'
    }
  }
}
</script>

<style scoped>
.emd-progress {
  border-radius: 4px;
}
</style>
